import React, { useState } from "react";
import { useSelector } from "react-redux";
import { myContactStyles as styles } from "./myContact.tailwind";
import ProfileImageSection from "./ProfileImageSection";
import { tabsConfig } from "./myContactInfoData.js"
import OverlayLoader from "../shared/Loaders/OverlayLoader/OverlayLoader.jsx";

const MyContactInfo = () => {
  const { user, userDetailsLoading } = useSelector((state) => state.user);
  const { updatingImage } = useSelector((state) => state.updateUser);
  const { userPointsAndRewards } = useSelector((state) => state.reward);
  const profileDetails= user?.userDetails;

  const [activeTab, setActiveTab] = useState(tabsConfig[0].id);

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
  };

  const resetTab = () => {
    setActiveTab(tabsConfig[0].id);
  }

  const RenderComponent = tabsConfig?.find((tab) => tab.id === activeTab)?.component;

  return (
    <div className={styles.outerContainer}>
      {(updatingImage || userDetailsLoading) && <OverlayLoader />}

      {/* Profile Image Section */}
      <ProfileImageSection user={user} userPointsAndRewards={userPointsAndRewards} />

      <div className={styles.myProfileSection}>
        <div className={styles.tabContainer} style={{ scrollbarWidth: "none" }}>
          {/* My Profile */}
          {/* <div onClick={() => handleTabChange(1)} className={`${styles.tab}`}> */}
            <button onClick={() => handleTabChange(1)} className={`${styles.tab} ${activeTab === 1 ? styles.activeButton2 : ''}`}>My Profile</button>
            {/* {activeTab === 1 && <div className={styles.activeTab}></div>} */}
          {/* </div> */}
          
          {/* Change Password */}
          {/* <div onClick={() => handleTabChange(2)} className={`${styles.tab} ${activeTab === 2 ? styles.activeButton2 : ''}`}> */}
            {/* <span className={styles.tabText}> */}
            <button onClick={() => handleTabChange(2)} className={`${styles.tab} ${activeTab === 2 ? styles.activeButton2 : ''}`}>
              {profileDetails?.hasPassword ? "Change Password" : "Set Password"}
            </button>
            {/* {activeTab === 2 && <div className={styles.activeTab}></div>} */}
          {/* </div> */}
        </div>

        {/* Divider Line */}
        <div className={styles.divider}></div>
        
        {/* Render Active Tab Content */}
        <div className="p-2">
          <RenderComponent resetTab={resetTab} />
        </div>
      </div>
    </div>
  );
};

export default MyContactInfo;
